import React from 'react';

let Link = ({ children, ...rest }) => (
  <a {...rest}>
    {children}
  </a>
);

export default Link;



// WEBPACK FOOTER //
// ./src/draftComponents/Link/Link.js